export const AUTH_CHECK = 'AUTH_CHECK';
export const AUTH_STORE = 'AUTH_STORE';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';

export default {
  AUTH_CHECK,
  AUTH_STORE,
  AUTH_LOGOUT,
};
